import MarkdownIt from "markdown-it";
// @ts-expect-error - no types
import taskLists from "markdown-it-task-lists";

// Build a GFM-flavored markdown-it instance.
// We render math placeholders here, and resolve them in a post-pass so that
// KaTeX can be lazy-loaded only when needed.
export function buildRenderer(): MarkdownIt {
  const md = new MarkdownIt({
    html: true,            // CLI is trusted; allow inline HTML
    linkify: true,
    breaks: false,
    typographer: false,
  });
  md.use(taskLists, { enabled: false, label: false, labelAfter: false });
  installMathRule(md);
  return md;
}

// $...$ inline and $$...$$ display math, escaped as marker spans/divs
// that the post-pass replaces with KaTeX output.
function installMathRule(md: MarkdownIt): void {
  md.inline.ruler.before("emphasis", "math_inline", (state, silent) => {
    if (state.src[state.pos] !== "$") return false;
    // $$...$$ is display math, handled by block rule when on its own line
    // but support inline $$x$$ too.
    const start = state.pos;
    const double = state.src[start + 1] === "$";
    const open = double ? 2 : 1;
    const end = findUnescaped(state.src, start + open, double ? "$$" : "$");
    if (end < 0) return false;
    const content = state.src.slice(start + open, end);
    if (!content.trim()) return false;
    if (!silent) {
      const token = state.push(double ? "math_display" : "math_inline", "", 0);
      token.markup = double ? "$$" : "$";
      token.content = content;
    }
    state.pos = end + open;
    return true;
  });
  md.renderer.rules.math_inline = (tokens, idx) =>
    `<span class="math-inline" data-tex="${escapeAttr(tokens[idx]!.content)}"></span>`;
  md.renderer.rules.math_display = (tokens, idx) =>
    `<div class="math-display" data-tex="${escapeAttr(tokens[idx]!.content)}"></div>`;
}

function findUnescaped(src: string, from: number, marker: string): number {
  let i = from;
  while (i < src.length) {
    const ch = src[i];
    if (ch === "\\") { i += 2; continue; }
    if (src.startsWith(marker, i)) return i;
    i++;
  }
  return -1;
}

function escapeAttr(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
}
